module.exports = {
  "country": "GR",
  "artist": "Klavdia",
  "song": "Asterometa",
  "year": "2025",
  "place": "6",
  "spotify": "2aE2SRm4QraCuDBNnBsRIz"
};